<div data-id="program-details" class="business-content loyalty-page-container" style="display: block">
  <div class="how-works-block">
    <div class="first-enrolling-container">
      <p>
        {{ loyaltyAmadeusPlusMeString }}
        {{ loyaltyEnrollBrandNewLoyaltyProgramString }}
      </p>

      <div class="icons-block">
        <svg style="height: 45px; width: 90px;">
          <use href="/assets/images/svg_ico/icons.svg#airplane"></use>
        </svg>

        <svg style="height: 45px; width: 45px;">
          <use href="/assets/images/svg_ico/icons.svg#hotel"></use>
        </svg>

        <svg style="height: 30px; width: 60px;">
          <use href="/assets/images/svg_ico/icons.svg#car"></use>
        </svg>

        <svg style="height: 45px; width: 36px;">
          <use href="/assets/images/svg_ico/icons.svg#insurance"></use>
        </svg>

        <span>=</span>

        <span i18n="@@loyalty-enroll-now.loyaltyEnrollPoints">Points</span>
      </div>

      <p i18n="@@loyalty-enroll-now.loyaltyEnrollEveryReservation">
        On every booking with Amadeus Selling Platform (Classic or Connect), you accumulate points for each
        air/hotel/car segment.
      </p>

      <p i18n="@@loyalty-enroll-now.loyaltyEnrollRegisterAndClaim">
        Once registered, claim your rewards in just 3 simple steps:
      </p>

      <div class="icons-block">
        <div class="ico-container">
          <svg style="height: 40px; width: 40px;">
            <use href="/assets/images/svg_ico/icons.svg#reservation"></use>
          </svg>
          <div i18n="@@loyalty-enroll-now.loyaltyEnrollIconMakeBooking" class="text-color">Make a booking</div>
        </div>

        <div class="arrow">
          <svg style="height: 24px; width: 24px; margin-bottom: 2em;">
            <use href="/assets/images/svg_ico/icons.svg#arrow_grey"></use>
          </svg>
        </div>

        <div class="ico-container">
          <svg style="height: 40px; width: 40px;">
            <use href="/assets/images/svg_ico/icons.svg#points"></use>
          </svg>
          <div i18n="@@loyalty-enroll-now.loyaltyEnrollIconAccumulatePoints" class="text-color">Accumulate points</div>
        </div>

        <div class="arrow">
          <svg style="height: 24px; width: 24px; margin-bottom: 2em;">
            <use href="/assets/images/svg_ico/icons.svg#arrow_grey"></use>
          </svg>
        </div>

        <div class="ico-container">
          <svg style="height: 40px; width: 40px;">
            <use href="/assets/images/svg_ico/icons.svg#rewards"></use>
          </svg>
          <div i18n="@@loyalty-enroll-now.loyaltyEnrollIconChooseReward" class="text-color">Choose your reward</div>
        </div>
      </div>

      <ng-container *ngIf="isAccountEnabled">
        <p class="coming-soon" i18n="@@loyalty-enroll-now.loyaltyProgramDetailsComingSoon">
          Coming soon! More benefits and opportunities to earn points. We'll keep you updated....
        </p>

        <div class="icons-block">
          <div class="ico-container">
            <svg style="height: 50px; width: 60px;">
              <use href="/assets/images/svg_ico/icons.svg#product_adoption"></use>
            </svg>
            <div i18n="@@loyalty-enroll-now.loyaltyProgramDetailsIconProductsAdoption">Products adoption</div>
          </div>

          <div class="ico-container">
            <svg style="height: 50px; width: 36px;">
              <use href="/assets/images/svg_ico/icons.svg#voice"></use>
            </svg>
            <div i18n="@@loyalty-enroll-now.loyaltyProgramDetailsIconShareYourVoice" class="text-color">
              Share your voice
            </div>
          </div>

          <div class="ico-container">
            <svg style="height: 50px; width: 60px;">
              <use href="/assets/images/svg_ico/icons.svg#community"></use>
            </svg>
            <div i18n="@@loyalty-enroll-now.loyaltyProgramDetailsIconCommunity" class="text-color">
              Community active involvement
            </div>
          </div>

          <div class="ico-container">
            <svg style="height: 50px; width: 35px;">
              <use href="/assets/images/svg_ico/icons.svg#seniority"></use>
            </svg>
            <div i18n="@@loyalty-enroll-now.loyaltyProgramDetailsIconSeniority" class="text-dark">Seniority</div>
          </div>

          <div class="ico-container">
            <svg style="height: 50px; width: 60px;">
              <use href="/assets/images/svg_ico/icons.svg#referrals"></use>
            </svg>
            <div i18n="@@loyalty-enroll-now.loyaltyProgramDetailsIconReferrals" class="text-color">Referrals</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!agencyParticipation && !isDecisionMaker">
        <p class="input_container" i18n="@@loyalty-enroll-now.loyaltyEnrollRequestDescription">
          To register and start earning points, just click on the button below. This will send a request to your manager
          to approve your request. Once approved, you can start earning those gifts!
        </p>
        <div class="reg-container input_container">
          <div class="input_container">
            <button
              class="btn btn-primary enroll-first"
              type="submit"
              id="enrollRequest"
              (click)="requestParticipation()"
              i18n="@@loyalty-enroll-now.loyaltyEnrollRequestButton"
            >
              Request approval for Amadeus+Me
            </button>
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="!isAccountEnabled && (isDecisionMaker || (!isDecisionMaker && agencyParticipation))"
        id="registrationLoyalty"
      >
        <form [formGroup]="enrollForm" (ngSubmit)="registerAgent(confirmCreateAccountModal)">
          <div class="reg-container input_container form-check">
            <input
              id="loyaltyAgree"
              formControlName="loyaltyAgree"
              type="checkbox"
              required
              class="form-check-input"
              [class.is-invalid]="validate && !enrollForm.controls['loyaltyAgree'].valid"
            />
            <label for="loyaltyAgree" class="form-check-label" i18n="@@loyalty-enroll-now.loyaltyEnrollTermsIHaveRead">
              I confirm that I have read, understood and agreed to the
            </label>
            <a href="{{ termsLink }}" i18n="@@loyalty-enroll-now.loyaltyEnrollTermsTermsLink"> Terms of use</a>
          </div>

          <div class="loyalty-enroll-form__actions">
            <button
              type="button"
              (click)="goToLoginForm('loginForm')"
              class="btn btn-outline-primary mb-2 me-0 me-md-2 loyalty-enroll-form__button-login"
            >
              {{ loyaltyEnrollSignInButtonString }}
            </button>
            <button
              type="submit"
              class="btn btn-primary mb-2 me-0 loyalty-enroll-form__button-ceate"
              id="enrollFirst"
              [disabled]="enrollForm.invalid"
              i18n="@@loyalty-enroll-now.loyaltyEnrollCreateButton"
            >
              Create account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #confirmCreateAccountModal let-continue="close" let-back="dismiss">
  <div class="modal-header">
    <h2 class="modal-title" i18n="@@loyalty-enroll-now.createAccountHeading">Already have an account?</h2>
  </div>
  <div class="modal-body">
    <label i18n="@@loyalty-enroll-now.createAccountContent"
      >Creating a new account with a previously used email will cancel the old account without transferring the
      accumulated points. Do you want to continue?</label
    >
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="back()" i18n="@@loyalty-enroll-now.buttonBack">
      Go Back
    </button>
    <button
      id="loyalty-tile-ok-button"
      type="button"
      class="btn btn-primary"
      (click)="continue()"
      i18n="@@loyalty-enroll-now.commonContinue"
    >
      Continue
    </button>
  </div>
</ng-template>
